import { BaseModel, RecursivePartial } from '@models/base';
import { ParamsFilterField } from './params-filter-field';

export class ParamsFilter extends BaseModel {
    logic?: 'or' | 'and';
    fields?: (ParamsFilter | ParamsFilterField)[];

    constructor(json?: RecursivePartial<ParamsFilter>) {
        super(json);
        this.parseParamsFilter(json || {});
    }

    parse(json: RecursivePartial<ParamsFilter>): ParamsFilter {
        super.parse(json);
        this.parseParamsFilter(json);
        return this;
    }

    private parseParamsFilter(json: RecursivePartial<ParamsFilter>): void {
        if (json.logic && typeof json.logic == 'string') {
            this.logic = json.logic.toLowerCase() as any;
        }
        if (json.fields && Array.isArray(json.fields)) {
            this.fields = [];
            for (const ff of json.fields) {
                this.fields.push((ff as ParamsFilter)?.logic ? new ParamsFilter(ff as ParamsFilter) : new ParamsFilterField(ff as ParamsFilterField));
            }
        }
    }
}
